import CloseIcon from '@/assets/imgs/close.svg?react'
import { GENERICS as dict } from '@/resources/dict'
import * as S from './styles'

interface Props {
  id: string
  title: string
  onClose: () => void
}

const Header = ({ id, title, onClose }: Props) => {
  return (
    <S.ModalHeader>
      <S.ModalTitle>{title}</S.ModalTitle>
      <S.ModalCloseButton id={`${id}-close-button`} onClick={onClose}>
        <CloseIcon />
        {dict.close}
      </S.ModalCloseButton>
    </S.ModalHeader>
  )
}

export default Header
